var PaymentFlow;
(function(PaymentFlow) {
    PaymentFlow["REDIRECT"] = 'Redirect';
    PaymentFlow["ACTIONLESS"] = 'Actionless';
    PaymentFlow["QR_CODE"] = 'QrCode';
    PaymentFlow["UNDEFINED"] = 'Undefined';
})(PaymentFlow || (PaymentFlow = {}));
var PaymentResult;
(function(PaymentResult) {
    PaymentResult["Success"] = 'success';
    PaymentResult["Approved"] = 'approved';
    PaymentResult["Pending"] = 'pending';
    PaymentResult["Failed"] = 'failed';
    PaymentResult["Redirect"] = 'redirect';
    PaymentResult["Error"] = 'error';
    PaymentResult["Cancelled"] = 'cancelled';
    PaymentResult["Refused"] = 'refused';
    PaymentResult["InternalError"] = 'internal-error';
    PaymentResult["Received"] = 'received';
})(PaymentResult || (PaymentResult = {}));

export { PaymentFlow, PaymentResult };
//# sourceMappingURL=types.js.map
